import axios from 'axios';
import { getAuthHeaders, handleAuthError } from './auth';

const API_BASE_URL = 'https://maindashbe-june-b18731a0e161.herokuapp.com';
export const PENDING_VERIFICATION_CODE_KEY = 'pending_verification_code';
export const VALIDATED_VERIFICATION_CODE_KEY = 'validated_verification_code';

export function savePendingVerificationCode(code) {
  if (code) {
    localStorage.setItem(PENDING_VERIFICATION_CODE_KEY, code);
  }
}

export function getValidatedVerificationCode() {
  return localStorage.getItem(VALIDATED_VERIFICATION_CODE_KEY);
}

export function accountNumberLooksLikeVerificationCode(accountNumber, verificationCode) {
  if (!accountNumber || !verificationCode) {
    return false;
  }
  if (accountNumber === verificationCode) {
    return true;
  }
  const digitsOnly = verificationCode.replace(/[^0-9]/g, '');
  return Boolean(digitsOnly) && accountNumber === digitsOnly;
}

export function getAccountNumberMisentryMessage(action) {
  const setupCodeLabel =
    action === 'add_ss' || action === 'add_ss_lite' || action === 'ssi'
      ? 'FT9ja Account Setup Code'
      : 'Verification Code';
  const accountLabel =
    action === 'add_aso_ss' ? 'new account number' : 'MT5 trading account number';

  return `This looks like your ${setupCodeLabel}, not your ${accountLabel}. Enter your trading account number here and put the code in the "${setupCodeLabel}" field below.`;
}

export async function validatePendingVerificationCode(accessToken) {
  const pendingCode = localStorage.getItem(PENDING_VERIFICATION_CODE_KEY);
  if (!pendingCode) {
    return false;
  }

  try {
    await axios.post(
      `${API_BASE_URL}/selfservice/validate-verification-code/`,
      { code: pendingCode },
      {
        headers: {
          ...getAuthHeaders(),
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    localStorage.setItem(VALIDATED_VERIFICATION_CODE_KEY, pendingCode);
    localStorage.removeItem(PENDING_VERIFICATION_CODE_KEY);
    return true;
  } catch (error) {
    if (handleAuthError(error)) {
      return false;
    }
    localStorage.removeItem(PENDING_VERIFICATION_CODE_KEY);
    localStorage.removeItem(VALIDATED_VERIFICATION_CODE_KEY);
    return false;
  }
}
